import { getCurrencySymbol } from '../get-currency-symbol/util.js';
import { splitAmount } from '../split-amount/util.js';

const AMOUNT_MAJOR_PART_SIZE = 3;
const AMOUNT_SPLIT_CODE_FROM = 4;
// Reference: https://jkorpela.fi/dashes.html
const NEGATIVE_SYMBOLS = {
    /** Unicode: U+2212. An arithmetic operator */
    'minus-sign': '−',
    /** Unicode: U+002D. The Ascii hyphen. Used in inputs */
    'hyphen-minus': '-',
};
const THINSP = String.fromCharCode(8201); // &thinsp;
const MMSP = String.fromCharCode(8287); // средний математический пробел
const AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR = ',';
/**
 * Возвращает код для валюты взависимости от формата
 */
const getCurrencyCodeWithFormat = (currency, codeFormat) => {
    if (!currency) {
        return '';
    }
    return codeFormat === 'symbolic'
        ? getCurrencySymbol(currency)
        : currency;
};
/**
 * Возвращает разделитель для кода валюты взависимости от формата
 */
const getCurrencySeparator = (codeFormat) => (codeFormat === 'symbolic' ? THINSP : MMSP);
/**
 * Форматирует значение вместе с кодом валюты
 */
const formatWithCurrency = (value, currencyCode, separator) => [value, currencyCode].filter(Boolean).join(separator);
/**
 * Форматирует значение суммы
 * согласно гайдлайну https://design.alfabank.ru/patterns/amount
 */
const formatAmount = ({ value, currency, minority, view, negativeSymbol = 'minus-sign', codeFormat = 'symbolic', }) => {
    const currencySymbol = getCurrencyCodeWithFormat(currency, codeFormat);
    const currencySeparator = getCurrencySeparator(codeFormat);
    if (value === null) {
        return {
            majorPart: '',
            minorPart: '',
            formatted: '',
            currencySymbol,
            currencySeparator,
            formattedWithCurrency: formatWithCurrency(value, currencySymbol, currencySeparator),
        };
    }
    // eslint-disable-next-line no-param-reassign
    minority = minority === 0 ? 1 : minority; // because Math.log(0) => -Infinity
    const fractionDigits = Math.log(minority) * Math.LOG10E;
    const valueAbsStr = (Math.abs(value) / minority).toFixed(fractionDigits);
    const [majorPart, minorPartParsed = ''] = valueAbsStr.split('.');
    let minorPart = minorPartParsed;
    if (view === 'default' && value % minority === 0) {
        minorPart = '';
    }
    const majorPartSplitted = splitAmount(majorPart, AMOUNT_MAJOR_PART_SIZE, MMSP, AMOUNT_SPLIT_CODE_FROM);
    const majorPartFormatted = value < 0 ? NEGATIVE_SYMBOLS[negativeSymbol] + majorPartSplitted : majorPartSplitted;
    const formattedValueStr = minorPart
        ? majorPartFormatted + AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR + minorPart
        : majorPartFormatted;
    return {
        majorPart: majorPartFormatted,
        minorPart,
        currencySymbol,
        formatted: formattedValueStr,
        currencySeparator,
        formattedWithCurrency: formatWithCurrency(formattedValueStr, currencySymbol, currencySeparator),
    };
};

export { AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR, MMSP, NEGATIVE_SYMBOLS, THINSP, formatAmount };
